import {Component, OnInit, Input, Optional, Self} from '@angular/core';
import {NgControl} from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import {BaseAnswerTypeComponent} from "../base-answer-type.component";
import {ComparableOperator, PosibleAnswer} from "../../../../models/form";

@Component({
  selector: 'app-radio-group-input',
  templateUrl: './radio-group.component.html',
  styleUrls: ['./radio-group.component.scss']
})
export class RadioGroupComponent extends BaseAnswerTypeComponent<number> implements OnInit {
  @Input() placeholder: string = '';
  @Input() label: string;

  _items$: BehaviorSubject<PosibleAnswer[]>;
  get items(): PosibleAnswer[] {
    return this._items$.getValue();
  }
  @Input() set items(value: PosibleAnswer[]) {
    this._items$.next(value);
  }

  constructor(
    @Self()
    @Optional()
    ngControl?: NgControl,
  ) {
    super(ngControl);
    this._items$ = new BehaviorSubject<PosibleAnswer[]>([]);
  }

  ngOnInit() {
  }

  getItemDescription(id: number): string {
    return this._items$.getValue().filter(x => x.id == id)[0].description;
  }

  AllowedOperators: {[K in ComparableOperator]: (target: number, value: string) => boolean} = {
    [ComparableOperator.Equal]: (t, value: string) => t == Number(value),
    [ComparableOperator.NotEqual]: (t, value) => t != Number(value),
    [ComparableOperator.Contains]: null,
    [ComparableOperator.StartWith]: null,
    [ComparableOperator.EndWith]: null,
    [ComparableOperator.In]: (t, value: string) => value.split(';').map(v => Number(v)).includes(t),
    [ComparableOperator.GreaterThan]: null,
    [ComparableOperator.GreaterThanOrEqual]: null,
    [ComparableOperator.LessThan]: null,
    [ComparableOperator.LessThanOrEqual]: null,
    [ComparableOperator.IsNullOrEmpty]: (t) => !t,
    [ComparableOperator.NotIsNullOrEmpty]: (t) => !!t,
    [ComparableOperator.Between]: null,
    [ComparableOperator.Empty]: null,
    [ComparableOperator.Completed]: null,
  }
}
